<div style="height: 400px;">
    <div class="d-flex" style="width: 100%;">
        <div class="my-2">
            <img src="/assets/logo.jpg" width="35">
        </div>
        <div class="m-2">
            <h1>Let's Make Something Together!</h1>
        </div>
    </div>
    <div>
        <p>
            The majority of the pieces on this website were custom pieces commissioned by someone that wanted something special for themselves or as a gift.
        </p>
        <p>
            If you would like something special for yourself or as a gift I am happy to work with you on something similar to a previous piece, or something completely original.
        </p>
        <p>
            In most cases I speak the customer on the phone or communicate with email. 
            I am typically paid with <a href="http://cash.app">cash app</a> or <a href="https://venmo.com/">Venmo</a>. 
        </p>
        <p>
            If you would like to work on something with me please give me a call at 678-689-9552 or email me a 
            melissa@craftybymelissa.xyz. 
        </p>



    </div>
</div>